<template>
    <el-dialog :append-to-body="true" :visible.sync="chatGPTShow" class="productTypeDialog" custom-class="chatGPTDialog"
               destroy-on-close title="" width="60%" @close="close">
        <MobileChat @successfullyGenerated="successfullyGenerated" ref="MobileChat" :programmeInfo="programmeInfo">
        </MobileChat>
    </el-dialog>
</template>

<script>
// 这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
import MobileChat from './MobileChat.vue';

export default {
    name: '',
    components: {
        MobileChat
    },
    // 定义属性
    data() {
        return {
            chatGPTShow: false,
            programmeInfo:{}
        }
    },
    // 计算属性，会监听依赖属性值随之变化
    computed: {},
    // 监控data中的数据变化
    watch: {},
    // 方法集合
    methods: {
        close() {
            this.$refs.MobileChat.abortFetch();
        },
        successfullyGenerated() {
            this.chatGPTShow = false
            this.$emit('successfullyGenerated');
        },
        init(programmeInfo,chatType) {
            this.programmeInfo = programmeInfo
            this.chatGPTShow = true
            this.$nextTick(() => {
                this.$refs.MobileChat.sendTextPost(chatType)
          })
        },
    },
    // 生命周期 - 创建完成（可以访问当前this实例）
    created() {

    },
    // 生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {

    },
    beforeCreate() {
    }, // 生命周期 - 创建之前
    beforeMount() {
    }, // 生命周期 - 挂载之前
    beforeUpdate() {
    }, // 生命周期 - 更新之前
    updated() {
    }, // 生命周期 - 更新之后
    beforeDestroy() {
    }, // 生命周期 - 销毁之前
    destroyed() {
    }, // 生命周期 - 销毁完成
    activated() {
    }, // 如果页面有keep-alive缓存功能，这个函数会触发
}
</script>

<style>
.chatGPTDialog > .el-dialog__header {
    display: none;
}

.chatGPTDialog > .el-dialog__body {
    padding: 0;
}

.chatGPTDialog > .el-dialog__body > .mobile-chat-wrapper {
    height: 80vh;
}
</style>